import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { CstmPagination } from "components/Common/Common";
import { Link } from "react-router-dom";
import TableLayout from "components/TableLayout";
import { CHATTER_EVENT_DETAIL } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useGetChatterProgramListQuery } from "store/services/chatterPrograms";
import { convertToMomentDate, convertToMomentTime, userFullName } from "helpers/common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import DatePicker from "react-datepicker";
import { CalendarIcon } from "Assets/icons";

const ChatterEvent = () => {

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({
    search: "",
    status: "active",
    start_date: null,
    end_date: null,
    sort: {
      column: "id",
      direction: "desc"
    }
  });

  const { data, isLoading, isError, isFetching } = useGetChatterProgramListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const column = [
    {
      head: (
        <>
          <div className="d-flex align-items-center gap-10">
            Program Name
          </div>{" "}
        </>
      ),
      accessor: "ChatterEvent",
      isComponent: true,
      component: (item, ind) => (
        <>
          <div className="d-flex align-items-center gap-10">
            <h6 className="m-0 fw-sbold text-capitalize">{item.name || "--"}</h6>
          </div>
        </>
      ),
    },
    {
      head: "Start Date",
      accessor: "StartDate",
      isComponent: true,
      component: (item, ind) => (
        <>
          {item?.start_date ? convertToMomentDate(item?.start_date) : "--"}
        </>
      ),
    },
    {
      head: "End Date",
      accessor: "EndDate",
      isComponent: true,
      component: (item, ind) => (
        <>
          {item?.end_date ? convertToMomentDate(item?.end_date) : "--"}
        </>
      ),
    },
    {
      head: "Day",
      accessor: "Day",
      isComponent: true,
      component: (item, ind) => (
        <div className="text-capitalize">
          {item?.days?.map((x, i) => <span key={i} className="text-capitalize">{`${x}${i !== item?.days?.length - 1 ? ", " : ""}`}</span>) || "--"}
        </div>
      ),
    },
    {
      head: "Time",
      accessor: "Time",
      isComponent: true,
      component: (item, ind) => (
        <>
          {item?.time ? convertToMomentTime(item?.time) : "--"}
        </>
      ),
    },
    {
      head: "Location",
      accessor: "Location",
      component: (item, ind) => (
        <div className="text-capitalize">
          {item?.location || "--"}
        </div>
      ),
    },
    {
      head: "Location Type",
      accessor: "LocationType",
      component: (item, ind) => (
        <div className="text-capitalize">
          {item?.location_type || "--"}
        </div>
      ),
    }
  ];

  const resetFilter = () => {
    setFilter({ search: "", funding_source: "", status: "active", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };
  return (
    <>
      <section className="chatter position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">

                    <TableHeader
                      heading={" Chatter Program Profiles"}
                      handleFilterChange={handleFilterChange}
                      filter={filter}
                      resetFilter={resetFilter}
                      searchPlaceholder="Program Name"
                      filterComponent={
                        <>
                          <li>
                            <DatePicker
                              className="form-control forteen filter-datepicker"
                              placeholderText="Start Date"
                              selectsStart
                              icon={<CalendarIcon />}
                              showIcon
                              selected={filter?.start_date}
                              onChange={(value) => handleFilterChange("start_date")(value)}
                            />
                          </li>
                          <li>
                            <DatePicker
                              className="form-control forteen filter-datepicker"
                              placeholderText="End Date"
                              selectsEnd
                              icon={<CalendarIcon />}
                              showIcon
                              selected={filter?.end_date}
                              onChange={(value) => handleFilterChange("end_date")(value)}
                            />
                          </li>
                        </>
                      }
                    />
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    <TableLayout
                      data={data?.records || []}
                      column={column}
                      url={CHATTER_EVENT_DETAIL.replace("/:id", "")}
                      handleSort={handleFilterChange("sort")}
                      filter={filter}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterEvent;
